import Route from 'cio/routes/base';

export default class TimeZoneMatchRoute extends Route {
  crumb() {
    return {
      name: 'Time Zone Match',
      path: 'actions.time_zone_match',
    };
  }

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.setProperties({
        customer: null,
        idOrEmail: null,
        requestedIdOrEmail: null,
      });
      if (controller.get('requestTest.last')) {
        controller.set('requestTest.last.value', null);
      }
    }
  }
}
